module.exports = __webpack_public_path__ + "static/media/copyLink.73df1d2a.svg";